import React, { useState, useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "remixicon/fonts/remixicon.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Header.css";
const Header = () => {
  const API_BASE_URL =
    process.env.REACT_APP_API_URL || "http://localhost:8000";
  const IMAGE_BASE_URL =
    process.env.REACT_APP_IMAGE_BASE_URL || "https://aanandam.com/image";
  const VIDEO_BASE_URL = process.env.REACT_APP_Video_BASE_URL;
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openAbout, setOpenAbout] = useState(false);
  const [openProjects, setOpenProjects] = useState(false);
  const [openGallery, setOpenGallery] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); // 👈 spinner state
  const [isSubmitting1, setIsSubmitting1] = useState(false); // 👈 spinner state
  const [isTransparent, setIsTransparent] = useState(true);
  const [topOffset, setTopOffset] = useState(true);
  const [showBrochurePopup, setShowBrochurePopup] = useState(false);
  // State for selected brochures
  const [selectedBrochures, setSelectedBrochures] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();

  const aboutRef = useRef(null);
  const projectsRef = useRef(null);
  const galleryRef = useRef(null);

  const handleNav = (path) => {
    navigate(path);
    setMobileOpen(false);
    setOpenAbout(false);
    setOpenProjects(false);
    setOpenGallery(false);
  };

  const handleGalleryNav = (sectionId) => {
    setMobileOpen(false);
    setOpenAbout(false);
    setOpenProjects(false);
    setOpenGallery(false);

    if (location.pathname === "/aanandamgallery") {
      if (sectionId) {
        const target = document.getElementById(`section-${sectionId}`) || document.getElementById(sectionId);
        if (target) {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
          window.history.replaceState(null, "", `#${sectionId}`);
        }
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
        window.history.replaceState(null, "", "/aanandamgallery");
      }
    } else {
      navigate(sectionId ? `/aanandamgallery#${sectionId}` : "/aanandamgallery");
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const threshold = window.innerHeight * 0.1;
      const belowThreshold = window.scrollY < threshold;
      setIsTransparent(location.pathname === "/" && belowThreshold);
      setTopOffset(location.pathname === "/" && belowThreshold);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (aboutRef.current && !aboutRef.current.contains(e.target))
        setOpenAbout(false);
      if (projectsRef.current && !projectsRef.current.contains(e.target))
        setOpenProjects(false);
      if (galleryRef.current && !galleryRef.current.contains(e.target))
        setOpenGallery(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Check if user already submitted the form
    const hasSubmitted = localStorage.getItem("preRegisterSubmitted");

    // Show popup only if not submitted
    if (!hasSubmitted) {
      const timer = setTimeout(() => {
        setShowPopup(true);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => setShowPopup(false);

  // Open popup on brochure button click
  const handleBrochureClick = (e) => {
    e.preventDefault();
    setShowBrochurePopup(true);
  };

  const toggleSelection = (brochure) => {
    setSelectedBrochures((prev) =>
      prev.includes(brochure)
        ? prev.filter((b) => b !== brochure)
        : [...prev, brochure],
    );
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // start spinner

    const name = e.target.name.value.trim();
    const mobile = e.target.mobile.value.trim();
    const email = e.target.email.value.trim();

    // ✅ Validation: Mobile (10 digits)
    const mobileRegex = /^[0-9]{10}$/;
    if (!mobileRegex.test(mobile)) {
      toast.warn("📱 Please enter a valid 10-digit mobile number!");
      e.target.mobile.focus();
      setIsSubmitting(false);
      return;
    }

    // ✅ Validation: Email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.warn("📧 Please enter a valid email address!");
      e.target.email.focus();
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/send-mail`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ name, mobile, email, selectedBrochures }),
      });

      const result = await response.json();

      if (result.success) {
        selectedBrochures.forEach((brochure) => {
          const link = document.createElement("a");
          link.href =
            brochure === "brochure1"
              ? `${process.env.PUBLIC_URL || ""}/images/Aanandamvalleey_brochure.pdf`
              : `${process.env.PUBLIC_URL || ""}/images/Aanandamvalleey_brochure.pdf`;
          link.download =
            brochure === "brochure1"
              ? "AanandamValley-Brochure-1.pdf"
              : "AanandamValley-Brochure-2.pdf";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });

        toast.success("Form submitted successfully!");
        setSelectedBrochures([]);
        setShowBrochurePopup(false);
      } else {
        toast.error("❌ Mail sending failed!");
      }
    } catch (error) {
      console.error("Error sending mail:", error);
      toast.error("⚠️ Something went wrong!");
    } finally {
      setIsSubmitting(false); // stop spinner
    }
  };

  const handlePreRegister = async (e) => {
    e.preventDefault();
    setIsSubmitting1(true); // start spinner

    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());

    try {
      const res = await fetch(`${API_BASE_URL}/send-mail`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      if (res.ok) {
        toast.success("Thank you for pre-registering!");
        localStorage.setItem("preRegisterSubmitted", "true"); // store submission
        setShowPopup(false);
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Server error. Please try later.");
    } finally {
      setIsSubmitting1(false); // stop spinner
    }
  };
  return (
    <>
      <nav
        className={`site-navbar ${isTransparent ? "transparent" : ""} ${topOffset ? "offset" : "pinned"
          }`}
      >
        <Container
          fluid
          className="px-4 d-flex align-items-center justify-content-between"
        >
          <div className="footer-logo">
            <img
              src={`${IMAGE_BASE_URL}/logooo.png`}
              className="img-fluid imagii"
              alt="Logo"
            />
          </div>

          <div
            className={`hamburger ${mobileOpen ? "active" : ""}`}
            onClick={() => setMobileOpen((o) => !o)}
          >
            <span />
            <span />
            <span />
          </div>

          <div
            className={`collapse navbar-collapse ${mobileOpen ? "show" : ""}`}
          >
            <div className="nav-items">
              <div className="nav-item">
                <div className="nav-link" onClick={() => handleNav("/")}>
                  Home
                </div>
              </div>

              {/* About Us */}
              <div className="nav-item dropdown-wrapper" ref={aboutRef}>
                <div
                  className={`dropdown-toggle2 nav-link ${openAbout ? "open" : ""
                    }`}
                  onClick={() => setOpenAbout((o) => !o)}
                >
                  About Us
                  <i className="ri-arrow-down-s-line dropdown-icon"></i>
                </div>
                {openAbout && (
                  <div className="dropdown-menu show">
                    <button
                      className="dropdown-item"
                      onClick={() => handleNav("/about-us")}
                    >
                      About Us
                    </button>
                    <button
                      className="dropdown-item"
                      onClick={() => handleNav("/about-barsana")}
                    >
                      About Barsana
                    </button>
                  </div>
                )}
              </div>

              {/* Projects */}
              {/* <div className="nav-item dropdown-wrapper" ref={projectsRef}>
                <div
                  className={`dropdown-toggle2 nav-link ${
                    openProjects ? "open" : ""
                  }`}
                  onClick={() => setOpenProjects((o) => !o)}
                >
                  Projects
                  <i className="ri-arrow-down-s-line dropdown-icon"></i>
                </div>
                {openProjects && (
                  <div className="dropdown-menu show">
                    <button
                      className="dropdown-item"
                      onClick={() => handleNav("")}
                    >
                      Real Estate
                    </button>
                    <button
                      className="dropdown-item"
                      onClick={() => handleNav("/properties")}
                    >
                      Properties
                    </button>
                  </div>
                )}
              </div> */}
              <div className="nav-item">
                <div
                  className="nav-link"
                  onClick={() => handleNav("/developer")}
                >
                  Devlopers
                </div>
              </div>
              {/* Aanandam Gallery Dropdown */}
              <div
                className="nav-item dropdown-wrapper"
                ref={galleryRef}
                onMouseEnter={() => setOpenGallery(true)}
                onMouseLeave={() => setOpenGallery(false)}
              >
                <div
                  className={`dropdown-toggle2 nav-link ${location.pathname === "/aanandamgallery" ? "active-nav" : ""
                    } ${openGallery ? "open" : ""}`}
                  onClick={() => setOpenGallery((o) => !o)}
                >
                  <span
                    onClick={(e) => {
                      if (window.innerWidth >= 992) {
                        e.stopPropagation();
                        handleGalleryNav("");
                      }
                    }}
                  >
                    Aanandam Gallery
                  </span>
                  <i className={`ri-arrow-down-s-line dropdown-icon ${openGallery ? "rotate-icon" : ""}`}></i>
                </div>
                {openGallery && (
                  <div className="dropdown-menu show">
                    <button
                      className="dropdown-item"
                      onClick={() => handleGalleryNav("images")}
                    >
                      <i className="ri-image-line me-2"></i> Images
                    </button>
                    <button
                      className="dropdown-item"
                      onClick={() => handleGalleryNav("drawn-images")}
                    >
                      <i className="ri-draft-line me-2"></i> Drawn Images
                    </button>
                    <button
                      className="dropdown-item"
                      onClick={() => handleGalleryNav("reels")}
                    >
                      <i className="ri-film-line me-2"></i> Reels
                    </button>
                  </div>
                )}
              </div>
              <div className="nav-item">
                <div className="nav-link" onClick={() => handleNav("/blog")}>
                  Blogs
                </div>
              </div>
              <div className="nav-item">
                <div className="nav-link" onClick={() => handleNav("/contact")}>
                  Contact Us
                </div>
              </div>
              <div className="nav-item">
                <span
                  className="nav-link"
                  style={{ cursor: "pointer" }}
                  onClick={handleBrochureClick}
                >
                  Download Brochure
                </span>
              </div>
            </div>

            <div className="phone-link-wrapper ms-auto ">
              <span className="my-nom">Organize Site View</span>
              <a href="tel:+919557019023" className="phone-link">
                <i
                  style={{ fontSize: "0.8rem" }}
                  className="bi bi-telephone-fill me-2"
                />
                +91 7900304949
              </a>
            </div>
          </div>
        </Container>
      </nav>
      {/* BROCHURE POPUP */}
      {showBrochurePopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <button
              className="close-btn"
              onClick={() => setShowBrochurePopup(false)}
            >
              ✕
            </button>

            <div className="row popup-inner">
              {/* LEFT SIDE */}
              <div className="col-md-4 popup-left">
                <h3>We Promise</h3>
                <ul>
                  <li>📞 Instant Call Back</li>
                  <li>🚗 Free Site Visit</li>
                  <li>💰 Unmatched Price</li>
                </ul>
                <video
                  className="bg-vide"
                  // src="/video/popup1-video.mp4"
                  src={`${VIDEO_BASE_URL}/popup1-video.mp4`}
                  type="video/mp4"
                  preload="auto"
                  muted
                  loop
                  playsInline
                  autoPlay
                  webkit-playsinline="true"
                ></video>
              </div>

              {/* RIGHT SIDE */}
              <div className="col-md-8 popup-right">
                <img
                  // src="./image/sidelogo.png"
                  src={`${IMAGE_BASE_URL}/sidelogo.png`}
                  alt="Logo"
                  className="popup-logo"
                />
                <h4>
                  Select Brochure(s) and <span>Register Below!</span>
                </h4>

                {/* FORM */}
                <form onSubmit={handleSubmit}>
                  <input type="text" name="name" placeholder="Name" required />
                  <input
                    type="text"
                    name="mobile"
                    placeholder="Mobile No"
                    pattern="[0-9]{10}"
                    maxLength="10"
                    inputMode="numeric"
                    required
                    onInput={(e) => {
                      // allow only numbers
                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    }}
                  />

                  <input
                    type="email"
                    name="email"
                    placeholder="E-Mail Address"
                    required
                  />

                  {/* BROCHURE SELECTION CARDS */}
                  <div className="brochure-selection">
                    <div
                      className={`brochure-card ${selectedBrochures.includes("brochure1")
                        ? "selected"
                        : ""
                        }`}
                      onClick={() => toggleSelection("brochure1")}
                    >
                      <img
                        // src="/image/pdf.png"
                        src={`${IMAGE_BASE_URL}/pdf.png`}
                        alt="Brochure 1"
                        className="brochure2-thumb"
                      />
                      <p className="mb-0">Brochure 1</p>
                    </div>

                    <div
                      className={`brochure-card ${selectedBrochures.includes("brochure2")
                        ? "selected"
                        : ""
                        }`}
                      onClick={() => toggleSelection("brochure2")}
                    >
                      <img
                        // src="/image/pdf.png"
                        src={`${IMAGE_BASE_URL}/pdf.png`}
                        alt="Brochure 2"
                        className="brochure2-thumb"
                      />
                      <p className="mb-0">Brochure 2</p>
                    </div>
                  </div>

                  {/* SUBMIT BUTTON WITH SPINNER */}
                  <button
                    type="submit"
                    disabled={selectedBrochures.length === 0 || isSubmitting}
                  >
                    {isSubmitting ? <div className="spinner"></div> : "Submit"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* --- Popup Modal --- */}

      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <button className="close-btn" onClick={() => setShowPopup(false)}>
              ✕
            </button>

            <div className="row popup-inner">
              {/* LEFT SIDE */}
              <div className="col-md-4 popup-left">
                <h3>We Promise</h3>
                <ul>
                  <li>📞 Instant Call Back</li>
                  <li>🚗 Free Site Visit</li>
                  <li>💰 Unmatched Price</li>
                </ul>

                <video
                  className="bg-vide"
                  src={`${VIDEO_BASE_URL}/popup-video.mp4`}
                  type="video/mp4"
                  preload="auto"
                  muted
                  loop
                  playsInline
                  autoPlay
                  webkit-playsinline="true"
                ></video>
              </div>

              {/* RIGHT SIDE */}
              <div className="col-md-8 popup-right">
                <img
                  // src="./image/sidelogo.png"
                  src={`${IMAGE_BASE_URL}/sidelogo.png`}
                  alt="Logo"
                  className="popup-logo"
                />
                <h4>
                  Register Here And Avail <span>The Best Offers!!</span>
                </h4>
                <form onSubmit={handlePreRegister}>
                  <input type="text" name="name" placeholder="Name" required />
                  <input
                    type="text"
                    name="mobile"
                    placeholder="Mobile No"
                    pattern="[0-9]{10}"
                    maxLength="10"
                    inputMode="numeric"
                    required
                    onInput={(e) => {
                      // allow only numbers
                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    }}
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="E-Mail Address"
                    required
                  />
                  {/* SUBMIT BUTTON WITH SPINNER */}
                  <button type="submit">
                    {isSubmitting1 ? (
                      <div className="spinner"></div>
                    ) : (
                      "Pre-Register Now"
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
